import { MachineResponse } from "@/types/machine/machine";

export const getAllMachines = async (): Promise<MachineResponse[]> => {
  const response = await fetch("/api/v1/machines?limit=500", {   // 500 OK: machines are polled for status
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to get all machines");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : [];
};

export const getMachineById = async (name: string): Promise<MachineResponse> => {
  const response = await fetch(
    `/api/v1/machines/detail?name=${encodeURIComponent(name)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to get machine by id");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const getMachineByDeviceEui = async (deviceEui: string): Promise<MachineResponse | null> => {
  const response = await fetch(
    `/api/v1/machines/by-device-eui?device_eui=${encodeURIComponent(deviceEui)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to get machine by device_eui");
  const result = await response.json();
  return (result?.data?.item as MachineResponse) ?? null;
};

export const createMachine = async (machine: any): Promise<any> => {
  const response = await fetch("/api/v1/machines", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(machine),
  });
  if (!response.ok) throw new Error("Failed to create machine");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const updateMachine = async (name: string, machine: any): Promise<any> => {
  const response = await fetch("/api/v1/machines/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, ...machine }),
  });
  if (!response.ok) throw new Error("Failed to update machine");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const deleteMachine = async (name: string): Promise<any> => {
  const response = await fetch("/api/v1/machines/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!response.ok) throw new Error("Failed to delete machine");
  const result = await response.json();
  return result?.data ?? result;
};

export const getAllMachinesAndPrices = async (): Promise<any> => {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const response = await fetch("/api/v1/machines/prices?limit=500", {
    method: "GET",
    headers,
  });
  if (!response.ok) {
    throw new Error(`Failed to get all machines and prices: ${response.status} ${response.statusText}`);
  }
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : result?.data ?? result;
};
